import { GetDistributorsListingSchema } from '../schemas/DistributorZodSchema';
import { Distributor } from '../types/Distributor';

export function transformDistributorResponse(data?: unknown): Distributor[] {
    const parsedResult = GetDistributorsListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error('Validation failed for getDistributorsListing:', parsedResult.error.errors);
        return [];
    }

    const parsedDistributors = parsedResult.data.getObjectFolder.children;

    return parsedDistributors.map((d) => ({
        id: d.id,
        key: d.key,
        name: d.name,
        isGlobal: d.isGlobal,
        isFeatured: d.isFeatured,
        url: d.url ?? null,
        phone: d.phone ?? null,
        logo: d.logo ?? null,
        countryIds: d.countries ? d.countries.map((c) => c.id) : [],
        freeFormText: d.text ?? null, // Ensure freeFormText is set to null if undefined
    }));
}
